import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Menu, X, Download } from "lucide-react";
import { api, API } from "@/lib/api";

const NAV_LINKS = [
  { href: "#how-it-works", label: "Как это работает", testid: "landing-nav-how-it-works" },
  { href: "#advantages", label: "Преимущества", testid: "landing-nav-advantages" },
  { href: "#pricing", label: "Тарифы", testid: "landing-nav-pricing" },
  { href: "/verify", label: "Проверка", external: true, testid: "landing-nav-verify" },
  { href: "/about", label: "О компании", external: true, testid: "landing-nav-about" },
];

export function LandingHeader() {
  const [open, setOpen] = useState(false);
  const [latestRelease, setLatestRelease] = useState(null);

  useEffect(() => {
    api
      .get("/releases/latest")
      .then(({ data }) => setLatestRelease(data))
      .catch(() => setLatestRelease(null));
  }, []);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-white/80 border-b border-slate-200/80"
      data-testid="landing-header-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="landing-header-logo">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#4E9BEE] to-[#2563EB] flex items-center justify-center shadow-md shadow-blue-200">
            <Lock className="w-4.5 h-4.5 text-white" />
          </div>
          <span className="text-slate-900 font-bold text-lg tracking-tight">КриптоДок</span>
        </a>

        <nav className="hidden md:flex items-center gap-5 xl:gap-7">
          {NAV_LINKS.map((l) =>
            l.external ? (
              <Link key={l.href} to={l.href} data-testid={l.testid} className="text-[13px] xl:text-sm whitespace-nowrap text-slate-600 hover:text-slate-900 transition-colors">
                {l.label}
              </Link>
            ) : (
              <a key={l.href} href={l.href} data-testid={l.testid} className="text-[13px] xl:text-sm whitespace-nowrap text-slate-600 hover:text-slate-900 transition-colors">
                {l.label}
              </a>
            )
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/login"
            data-testid="landing-header-login-btn"
            className="text-sm font-medium text-slate-700 hover:text-slate-900 px-4 py-2 transition-colors"
          >
            Войти
          </Link>
          <a
            href={latestRelease ? `${API}/releases/latest/download` : "/register"}
            data-testid="landing-header-download-btn"
            className="flex items-center gap-2 text-sm font-semibold text-white px-6 py-2.5 rounded-lg bg-green-600 hover:bg-green-700 active:scale-[0.98] transition-all shadow-md shadow-green-200"
          >
            <Download className="w-4 h-4" /> Установить в один клик
          </a>
          <Link
            to="/register"
            data-testid="landing-header-register-btn"
            className="text-sm font-semibold text-white px-4 py-2 rounded-lg bg-gradient-to-r from-[#4E9BEE] to-[#2563EB] hover:scale-[1.03] active:scale-[0.98] transition-transform shadow-md shadow-blue-200"
          >
            Зарегистрироваться
          </Link>
        </div>

        <button className="md:hidden text-slate-700" onClick={() => setOpen(!open)} data-testid="landing-header-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 px-4 py-4 space-y-3 bg-white">
          {NAV_LINKS.map((l) =>
            l.external ? (
              <Link key={l.href} to={l.href} data-testid={`${l.testid}-mobile`} className="block text-sm text-slate-600" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ) : (
              <a key={l.href} href={l.href} data-testid={`${l.testid}-mobile`} className="block text-sm text-slate-600" onClick={() => setOpen(false)}>
                {l.label}
              </a>
            )
          )}
          <div className="flex gap-3 pt-2">
            <Link
              to="/login"
              data-testid="landing-mobile-login-btn"
              className="flex-1 text-center text-sm font-medium text-slate-700 border border-slate-200 rounded-lg py-2"
            >
              Войти
            </Link>
            <a
              href={latestRelease ? `${API}/releases/latest/download` : "/register"}
              data-testid="landing-mobile-register-btn"
              className="flex-1 flex items-center justify-center gap-1.5 text-center text-sm font-semibold text-white rounded-lg py-2 bg-green-600 hover:bg-green-700"
            >
              <Download className="w-3.5 h-3.5" /> Установить
            </a>
          </div>
          <Link
            to="/register"
            data-testid="landing-mobile-register-link-btn"
            className="block text-center text-sm font-semibold text-white rounded-lg py-2 bg-gradient-to-r from-[#4E9BEE] to-[#2563EB]"
          >
            Зарегистрироваться
          </Link>
        </div>
      )}
    </header>
  );
}
